export interface MarkerItem {
  fieldTypeId: string | null;
  fieldName: string;
  imageBase64: string;
}
